import React from 'react'
import styles from './Deposit.module.scss'
import { Withdraw } from './Withdraw/Withdraw'
import { Icon } from 'components/Icon/Icon'
import { PopupSendDeposit } from './PopupSendDeposit/PopupSendDeposit'


export function Deposit() {
    const [showPopup, setShowPopup] = React.useState(false)
    const [valueDeposit, setValueDeposit] = React.useState(null)

    function closePopup() {
        setShowPopup(false)
    }

    function handleSubmit(value) {
        setShowPopup(true)
        setValueDeposit(value)
    }

    return (
        <>
            <div className={styles['wrapper']}>
                <div>
                    <div className={styles['icon']}>
                        <Icon name='coin_big' />
                    </div>
                    <div className={styles['description']}>
                        Choose deposit size
                        <br />
                        and send the link to whom
                        <br /> you love
                    </div>
                </div>
                <Withdraw onSubmit={handleSubmit} />
            </div>
            {showPopup && <PopupSendDeposit deposite={valueDeposit} onClose={closePopup} />}
        </>
    );
}

